export default __webpack_public_path__ + "static/media/Zoom_Logo.7f57c318.png";